<div [loadingOverlay]="isLoading">
  <div *ngIf="isRedo" class="row mb-3">
    <div class="col-md-12">
      <div class="alert alert-warning" role="alert">
        <strong>Redo Task:</strong> This is a Redo of a completed Google Integration Setup. Please check the website for
        our Google Snippets prior to implementing them.
        If our snippets are not present please implement them. If our snippets are present, please use the Verify
        Analytics and Search Console Installation button to ensure the tags are firing.
      </div>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-md-12">
      <ul class="list-group">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-2">
              <strong>Description</strong>
            </div>
            <div class="col-md-10" [innerHtml]="taskDescription"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 120px;">
    <div class="spinner-border text-primary" role="status" aria-label="Loading">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && checked">
    <div class="row my-5">
      <div class="col-md-12 text-center">
        <div *ngIf="verified" class="alert alert-success" role="alert">
          <strong>Search Console Verified</strong>
        </div>
        <div *ngIf="!verified" class="alert alert-warning" role="alert">
          <strong>Search Console - Not verified</strong>
          <p>Confirm the Search Console meta tag snippet, DNS TXT record, or GTM verification is in place, then verify again.
            Use the Google Integration Diagnostic below to find and correct common integration problems before workblocking.</p>
        </div>
      </div>
    </div>
  </div>

  @if (hasFailedVerification) {
    <div class="card mb-5">
      <div class="card-header">
        <strong>Google Integration Diagnostic</strong>
      </div>
      <div class="card-body">
        <app-google-integration-diagnostic-panel [customerId]="customerId" [taskId]="taskId"
          (diagnosticCompleted)="verifyGtmTag()"></app-google-integration-diagnostic-panel>
      </div>
    </div>
  }

  <div *ngIf="!isLoading">
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-7">
            <span>Copy and paste the HTML snippets as high as possible in their respective tags</span>
          </div>
          <div class="col-md-5 d-flex justify-content-end align-items-start" style="gap: 0.5rem;">
            <div class="d-flex flex-column align-items-center">
              <label for="gtmId" class="form-label mb-1">Tag Manager</label>
              <input id="gtmId" type="text" title="Google Tag Manager" class="form-control text-center"
                [ngModel]="details?.GtmId" readonly disabled />
            </div>
            <div class="d-flex flex-column align-items-center">
              <label for="gaId" class="form-label mb-1">Analytics</label>
              <input id="gaId" type="text" title="Google Analytics" class="form-control text-center"
                [ngModel]="details?.GaMeasurementId" readonly disabled />
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <div ngbAccordion>
              <div ngbAccordionItem [collapsed]="(checked && verified)">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton>Primary Installation</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <h6>&lt;head&gt;</h6>
                      <div class="my-3 ms-5">
                        <span>Google Tag Manager Snippet</span>
                        <textarea class="form-control text-muted font-monospace fs-08"
                          [ngModel]="details.GtmHeadHtmlTag" style="height:180px;" disabled="true"></textarea>
                      </div>
                      <div class="my-3 ms-5">
                        <span>Search Console Verification Snippet</span>
                        <textarea class="form-control text-muted font-monospace fs-08"
                          [ngModel]="details.ScVerificationHtmlTag" style="height: 65px;" disabled="true"></textarea>
                      </div>
                      <div class="my-5">
                        <h6>&lt;body&gt;</h6>
                        <div class="my-3 ms-5">
                          <span>Google Tag Manager NoScript Snippet</span>
                          <textarea class="form-control text-muted font-monospace fs-08"
                            [ngModel]="details.GtmNoScriptTag" disabled="true"></textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div ngbAccordionItem [collapsed]="true">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton>Alternate Installation Methods</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <div class="my-3">
                        <span>Google Analytics 4 Snippet</span>
                        <textarea class="form-control text-muted font-monospace fs-08" [ngModel]="details.GaHtmlTag"
                          style="height: 210px;" disabled="true"></textarea>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <ng-container *ngTemplateOutlet="verifyGtmTagButton"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <app-floating-panels>
    <app-floating-panel [displayConfig]="{ title: 'External Access', icon: 'fa-key', size: 'floating-panel-md' }">
      <app-components-specialist-external-access-read-only *floatingPanelContent [customer]="currentAction().Customer">
      </app-components-specialist-external-access-read-only>
    </app-floating-panel>
  </app-floating-panels>
</div>

<ng-template #verifyGtmTagButton>
  <div class="col-md-12 d-flex justify-content-center">
    <button class="btn btn-lg btn-primary p-3" (click)="verifyGtmTag()" [disabled]="isLoading">
      <i class="fas fa-check-circle fa-lg"></i> Verify Analytics and Search Console Installation
    </button>
  </div>
</ng-template>
